import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "dice3d-wrapper" }
const _hoisted_2 = ["id"]
const _hoisted_3 = {
  key: 0,
  class: "dice-loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["dice-stage", _ctx.tint])
    }, [
      _createElementVNode("div", {
        id: _ctx.canvasId,
        class: "dice-canvas"
      }, null, 8, _hoisted_2),
      (!_ctx.ready)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "loading dice…"))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["dice-rule", _ctx.tint])
    }, _toDisplayString(_ctx.ruleLabel), 3)
  ]))
}